import type { ComponentSchema } from '../../../../../schema-types'
import { schema as baseBanner } from '../banner/banner.schema'

/** Neon Cinema banner: the shared fields, plus the compact strip (v3) its markup draws for a stored v3. */
export const schema: ComponentSchema = {
  ...baseBanner,
  variants: [...baseBanner.variants, { id: 'v3', label: 'V3 (Compact strip)' }],
}
